import React, { useState } from 'react'

import { IMAGE } from '@ui-kit/assets/images/index.web'
import Icon from '@ui-kit/components/SvgIcon/index.web'
import { tableContent } from '@ui-kit/components/Table/TableCategoryAccordionContent/styles'
import TableRowContentValue from '@ui-kit/components/Table/TableRowContentValue/index.web'
import type { TableRow } from '@ui-kit/components/Table/types'

interface Props {
  rowContent: TableRow
  isFirst: boolean
}

const TableCategoryAccordionContent = (props: Props) => {
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(
    props.rowContent.isExpandedByDefault
  )
  const isExpandable = props.rowContent.description !== undefined
  const onDescriptionSectionClick = () => setIsDescriptionExpanded(!isDescriptionExpanded)
  const { row, value, titleContainer, descriptionTitleContainer, descriptionTitle, description } =
    tableContent({
      isFirst: props.isFirst,
    })

  return (
    <div className={row()} key={props.rowContent.key}>
      <div className={titleContainer()}>
        <div
          className={descriptionTitleContainer()}
          onClick={isExpandable ? onDescriptionSectionClick : undefined}
        >
          <span className={descriptionTitle()}>{props.rowContent.title}</span>
          {props.rowContent.description && (
            <Icon
              imgSrc={
                isDescriptionExpanded
                  ? IMAGE.icons.xsmall.action.circleInfoActive_16
                  : IMAGE.icons.xsmall.action.circleInfoDisabled_16
              }
            />
          )}
        </div>
        {props.rowContent.description && isDescriptionExpanded && (
          <span
            className={description()}
            dangerouslySetInnerHTML={{ __html: props.rowContent.description }}
          />
        )}
      </div>
      {/* table row data (string or boolean) */}
      {props.rowContent.rowData.map((rowContentValue) => (
        <TableRowContentValue
          className={value()}
          key={rowContentValue.key}
          rowContentValue={rowContentValue}
          isDescriptionExpanded={isDescriptionExpanded}
        />
      ))}
    </div>
  )
}

export default TableCategoryAccordionContent
